module.exports = __webpack_public_path__ + "img/feature-app-targeting.2f00d43.svg";